/**
 * Converte um caractere alfanumérico para seu valor numérico conforme regra da Receita Federal.
 * '0'-'9' → 0-9
 * 'A'-'Z' → 17-42
 */
function charToValue(char: string): number {
    const code = char.charCodeAt(0);
    if (code >= 48 && code <= 57) return code - 48;
    if (code >= 65 && code <= 90) return code - 48;
    return -1;
}

export function isValidAlphanumericCNPJ(cnpj: string): boolean {
    const cleaned = cnpj.replace(/[.\-\/]/g, '').toUpperCase();

    if (cleaned.length !== 14) return false;

    if (!/^[0-9A-Z]{14}$/.test(cleaned)) return false;

    // Rejeita sequências com todos os caracteres iguais
    if (/^(.)\1+$/.test(cleaned)) return false;

    const values = cleaned.split('').map(charToValue);
    if (values.some((v) => v < 0)) return false;

    // Os dois últimos dígitos verificadores devem ser numéricos (0-9)
    if (values[12] > 9 || values[13] > 9) return false;

    // Primeiro dígito verificador
    const weights1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    let sum1 = 0;
    for (let i = 0; i < 12; i++) {
        sum1 += values[i] * weights1[i];
    }
    const remainder1 = sum1 % 11;
    const digit1 = remainder1 < 2 ? 0 : 11 - remainder1;
    if (values[12] !== digit1) return false;

    // Segundo dígito verificador
    const weights2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    let sum2 = 0;
    for (let i = 0; i < 13; i++) {
        sum2 += values[i] * weights2[i];
    }
    const remainder2 = sum2 % 11;
    const digit2 = remainder2 < 2 ? 0 : 11 - remainder2;
    if (values[13] !== digit2) return false;

    return true;
}

